import MUICard from "@material-ui/core/Card";
import { Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { TipImage } from "./Image";
import { getCardSize } from "./size";

const styles = (theme: Theme) => {
  const { spacing, breakpoints, shadows } = theme;
  const { width, height } = getCardSize(theme);
  return {
    card: {
      "&:hover": {
        boxShadow: shadows[4]
      },
      borderRadius: spacing.unit * 2,
      cursor: "pointer",
      maxWidth: width,
      minHeight: height,
      transition: "box-shadow 0.5s ease",
      [breakpoints.down("sm")]: {
        width
      }
    },
    text: {
      padding: `${spacing.unit * 2}px ${spacing.unit * 2}px 0 ${spacing.unit * 2}px`
    }
  };
};

interface CardProps extends WithStyles<typeof styles> {
  title: string;
  imageUrl: string;
  onClick?: () => void;
}

export const BaseCard: React.FC<CardProps> = ({ classes, title, imageUrl, onClick }) => (
  <MUICard className={classes.card} onClick={onClick}>
    <TipImage imageUrl={imageUrl} />
    <Typography variant="body1" component="h3" className={classes.text}>
      {title}
    </Typography>
  </MUICard>
);

export const Card = withStyles(styles)(BaseCard);
